import React from "react";
import { Spin, Table, Typography } from "antd";
import PriceBox from "./RecommendPriceBox";
import { setPriceDetailDrawerVisible } from "../../controller/actions";
import { recommendPriceTableData } from "../../controller/stores";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import { getApiRecommendPriceDetail } from "../../controller/api";
import { calcPriceAdjust } from "./priceAdjust";
class RecommendPriceTable extends React.Component {
  state = {
    loading: false
  }
  getRecommendListData = () => {
    let mobxRecommendListData = toJS(recommendPriceTableData.data);
    if (mobxRecommendListData.length > 0) {
      const tableData = [
        { roomcategory: "twin" },
        { roomcategory: "double" },
        { roomcategory: "twin-double" },
        { roomcategory: "quad" },
        { roomcategory: "family" },
        { roomcategory: "presidential" },
      ];
      tableData.forEach((rowData) => {
        this.props.priceType.forEach((type) => {
          rowData[type.pricetype_id] = {};
          rowData[type.pricetype_id].pricetype_name = type.pricetype_name;
        });
      });
      mobxRecommendListData.forEach((priceTypeData) => {
        let type = priceTypeData.type;
        let dates = priceTypeData.dates;
        priceTypeData.data.forEach((cloumndetail) => {
          const index = tableData.findIndex(
            (tableData) =>
              tableData.roomcategory === cloumndetail.roomcategory_id
          );
          const recommendprice =
            cloumndetail.recommendprice !== null
              ? Math.ceil(cloumndetail.recommendprice)
              : null;
          const currentprice =
            cloumndetail.currentprice !== null
              ? Math.ceil(cloumndetail.currentprice)
              : null;
          if (!tableData[index][type]) return;
          tableData[index][type].dates = dates;
          tableData[index][type].pricetype_id = type;
          tableData[index][type].currentprice = currentprice;
          tableData[index][type].recommendprice = recommendprice;
          // 舊寫法在 currentprice 為 null 時因 JS 把 null 當 0，
          // 算出來的差額會等於整個建議價格，被當成巨幅上漲。
          const { amount, rate } = calcPriceAdjust(currentprice, recommendprice);
          tableData[index][type].priceadjust = amount;
          tableData[index][type].priceadjustrate = rate;
        });
      });
      return tableData;
    } else {
      return null;
    }
  };
  handleFetchDetail = (priceType) => {
    this.setState({ loading: true });
    getApiRecommendPriceDetail(priceType.dates, priceType.category)
      .then((response) => {
        // 排序交給 rankingRows.buildRankingRows —— 表格改依價格排序，
        // 且停用飯店要置底，不是單純的等級排序
        setPriceDetailDrawerVisible(true, priceType, response.data);
      }).finally(() => {
        this.setState({ loading: false });
      });
  };
  render() {
    const datasource = this.getRecommendListData();

    const columns = [
      {
        title: "房型",
        dataIndex: "roomcategory",
        width: "12%",
        render: (text, rowData) => {
          switch (text) {
            case "twin":
              return <Typography.Text strong>兩小床</Typography.Text>;
            case "double":
              return <Typography.Text strong>一大床</Typography.Text>;
            case "twin-double":
              return <Typography.Text strong>兩大床</Typography.Text>;
            case "quad":
              return <Typography.Text strong>四小床</Typography.Text>;
            case "family":
              return <Typography.Text strong>家庭房</Typography.Text>;
            default:
              return <Typography.Text strong>總統套房</Typography.Text>;
          }
        },
      },
    ];
    this.props.priceType.forEach((type) =>
      columns.push({
        title: type.pricetype_name,
        dataIndex: type.pricetype_id,
        width: "18%",
        render: (cloumnData, rowData) => {
          let pricetype = {
            category: rowData.roomcategory,
            priceType: cloumnData.pricetype_id,
            pricetype_name: cloumnData.pricetype_name,
            currentprice: cloumnData.currentprice,
            recommendprice: cloumnData.recommendprice,
            priceadjust: cloumnData.priceadjust,
            priceadjustrate: cloumnData.priceadjustrate,
            dates: cloumnData.dates,
          };
          return Array.isArray(cloumnData.dates) && cloumnData.dates.length > 0 ? (
            <PriceBox pricetype={pricetype} onHandleClick={this.handleFetchDetail.bind(this, pricetype)} />
          ) : (
            <Typography.Text type="secondary">-</Typography.Text>
          );
        },
      })
    );
    return (
      <Spin spinning={this.state.loading}>
        <Table
          rowKey="roomcategory"
          columns={columns}
          dataSource={datasource}
          scroll={{ x: 'max-content' }}
          pagination={false}
          size="small"
        />
      </Spin>
    );
  }
}
export default observer(RecommendPriceTable);
